import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

class ConversationsRow extends React.Component {
  constructor() {
    super()

    this.state = {
      isDropped: false,
    }

    this.handleDrop = this.handleDrop.bind(this)
  }

  handleDrop() {
    this.setState({ isDropped: !this.state.isDropped })
  }

  render() {
    return (
      <tr
        className={`dropable-row message-info
          ${this.state.isDropped ? 'is-droped' : ''}
          ${this.props.data.attributes.isUnread && 'is-unread'}
          ${this.props.data.attributes.checked && 'is-selected'}
        `}
      >
        <td data-th="Contact" onClick={this.handleDrop}>
          <div className="dropable-row__content">
            <input
              type="checkbox"
              id={`conversation-${this.props.index}`}
              className="checkbox"
              checked={this.props.data.attributes.checked}
              onChange={this.props.onChange}
              value={this.props.data.relationships.conversation.data.id}
              data-index={this.props.index}
            />
            <label htmlFor={`conversation-${this.props.index}`} />
            {this.props.data.attributes.username}
            <Icon
              className="dropable-row__trigger"
              type={['far', this.state.isDropped ? 'minus-circle' : 'plus-circle']}
            />
          </div>
        </td>
        <td data-th="Subject">
          <Link to={`/profile/inbox/conversations/${this.props.data.relationships.conversation.data.id}`}>
            {this.props.data.attributes.subject}
          </Link>
        </td>
        <td data-th="Type">{this.props.data.attributes.type}</td>
        <td data-th="Date Created">{this.props.data.attributes.createdAt}</td>
        <td data-th="Last Action">{this.props.data.attributes.updatedAt}</td>
        {this.props.data.attributes.isArchived ? (
          <td data-th="Remove from achive" className="u-text-center" onClick={this.props.unarchive} value={this.props.data.relationships.conversation.data.id}>
            <Icon type={['far', 'folder-open']} size="lg" notSpaced />
          </td>
        ) : (
          <td data-th="Move to achive" className="u-text-center" onClick={this.props.moveToArchive} value={this.props.data.relationships.conversation.data.id}>
            <Icon type="archive" size="lg" notSpaced />
          </td>
        )}
      </tr>
    )
  }
}

ConversationsRow.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    attributes: PropTypes.shape({
      username: PropTypes.string.isRequired,
      subject: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      updatedAt: PropTypes.string.isRequired,
      checked: PropTypes.bool.isRequired,
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  moveToArchive: PropTypes.func.isRequired,
  unarchive: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
}

export default ConversationsRow
